import { useEffect, useRef, useState } from 'react';
import './SearchDropDown.css';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

type AppOption = {
  label: string;
  value: string;
};

const SearchDropDown = (props: any) => {
  const {
    options,
    placeholder,
    selectedVal,
    handleChange,
    allowCustomValue = false,
    validationPattern,
    validationMessage
  } = props;
  const [filteredOptions, setFilteredOptions] = useState<AppOption[] | []>([]);
  const [selectedOption, setSelectedOption] = useState<AppOption | null>(null);
  const [inputValue, setInputValue] = useState<string>(selectedVal); // Manage input value separately
  const [customValidation, setCustomValidation] = useState('');
  useEffect(() => {
    if (selectedVal) {
      const matchedOption =
        options && options?.find((option: AppOption) => option.value === selectedVal);

      // if "matchedOption" is not available because of  dataTable Data update and user had used some old SPN , these condition are  used
      if (!!matchedOption) {
        setSelectedOption(matchedOption || null);
      } else if (!!selectedVal) {
        setSelectedOption({ label: selectedVal, value: selectedVal } || null);
      }
    }
  }, [selectedVal, options]);

  const handleInputChange = (input: string) => {
    setInputValue(input);
    setCustomValidation('');
    if (!input || input.length < 2) {
      setFilteredOptions([]);
      return;
    }
    const filtered = options.filter((option: AppOption) =>
      option.label.toLowerCase().includes(input.toLowerCase())
    );
    // commenting this slice , because it is restricting filter option to 50 items only.
    // setFilteredOptions(filtered.slice(0, 50));

    setFilteredOptions(filtered);
  };

  const setChosenOption = (option: any) => {
    setSelectedOption(option);
    setInputValue('');
    handleChange(option?.value || '');
  };

  const useCustomValue = (value: string) => {
    if (validationPattern && !validationPattern.test(value)) {
      setCustomValidation(validationMessage || 'Please enter a valid value');
      return;
    }

    const customOption = { label: value, value };
    setSelectedOption(customOption);
    setInputValue('');
    setCustomValidation('');
    handleChange(value);
  };

  if (allowCustomValue) {
    return (
      <>
        <CreatableSelect<AppOption>
          options={filteredOptions}
          value={selectedOption}
          onChange={setChosenOption}
          onCreateOption={useCustomValue}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          placeholder={placeholder}
          formatCreateLabel={(value) => `Use "${value}"`}
          isValidNewOption={(value) => value.length > 0}
          isClearable
          noOptionsMessage={() => 'Type a SAN value'}
          required
        />
        {customValidation && (
          <small style={{ color: 'red', display: 'block', marginTop: '4px' }}>
            {customValidation}
          </small>
        )}
      </>
    );
  }

  return (
    <Select<AppOption>
      options={filteredOptions}
      value={selectedOption}
      onChange={setChosenOption}
      onInputChange={handleInputChange}
      inputValue={inputValue}
      placeholder={placeholder}
      isClearable
      noOptionsMessage={() => 'Type atleast 2 characters'}
      required
    />
  );
};

export default SearchDropDown;
